module.exports = __webpack_public_path__ + "img/Blizzert_ticket_info_background.402cb859.jpg";